import React from 'react';

const TotemCard = ({
  venueName = "Gig Venue",
  totemLocation = "Sound Desk (Left Side)",
  hostName,
  meetTime = "19:30",
  mapImage,
  hostAvatar,
  onPress,
}) => {
  // Handle mapImage prop - support both { uri: '...' } and direct string
  const mapImageUrl = mapImage?.uri || mapImage || '';
  const hostAvatarUrl = hostAvatar?.uri || hostAvatar || '';

  return (
    <div 
      className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 border border-gray-700 shadow-2xl mb-4 cursor-pointer transition-opacity hover:opacity-90"
      onClick={onPress}
    >
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="w-12 h-12 bg-[#4ADE80] rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-[#050505]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <div className="text-right">
            <div className="text-white font-semibold">{venueName}</div>
            <div className="text-gray-400 text-sm">{totemLocation}</div>
          </div>
        </div>
        
        {mapImageUrl && (
          <div className="h-32 rounded-lg overflow-hidden">
            <img 
              src={mapImageUrl} 
              alt={`Map of ${venueName}`} 
              className="w-full h-full object-cover"
            />
          </div>
        )}
        
        {(hostName || meetTime || hostAvatarUrl) && (
          <div className="flex items-center justify-between pt-2 border-t border-gray-700">
            <div className="flex items-center gap-3">
              {hostAvatarUrl && (
                <img 
                  src={hostAvatarUrl} 
                  alt={hostName ? `${hostName}'s avatar` : 'Host avatar'} 
                  className="w-10 h-10 rounded-full object-cover"
                />
              )}
              {hostName && (
                <div>
                  <div className="text-white text-sm font-medium">Host: {hostName}</div>
                </div>
              )}
            </div>
            {meetTime && (
              <div className="text-[#4ADE80] text-sm font-medium">{meetTime}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TotemCard;
